<div
	id="kt_select_files"
	class="bg-body pay-select-files-z-index"
	data-kt-drawer="true"
	data-kt-drawer-name="select_files"
	data-kt-drawer-activate="true"
	data-kt-drawer-overlay="true"
	data-kt-drawer-width="{default:'100%', 'lg': '900px'}"
	data-kt-drawer-direction="end"
	data-kt-drawer-toggle="#kt_select_files_toggle"
	data-kt-drawer-close="#kt_select_files_close"
>
	<div class="card shadow-none rounded-0 w-100">
		<div class="card-header" id="kt_select_files_header">
			<div class="d-flex felx-row justify-content-between align-items-center">
				<div class="d-flex flex-column">
					<h3 class="card-title fw-bolder text-gray-900" translate>select_files_drawer_title</h3>
					<span class="text-muted fs-7 fw-semibold" translate>select_files_drawer_description</span>
				</div>
			</div>
		</div>
		<div class="card-body position-relative" id="kt_select_files_body">
			<div
				id="kt_select_files_scroll"
				class="position-relative scroll-y me-n5 pe-5"
				data-kt-scroll="true"
				data-kt-scroll-height="auto"
				data-kt-scroll-wrappers="#kt_select_files_body"
				data-kt-scroll-dependencies="#kt_select_files_header, #kt_select_files_footer"
				data-kt-scroll-offset="0px"
			>
				<div>
					<!-- List -->
					<div class="row g-5 g-xl-10 mb-5 mb-xl-10 px-3" *ngIf="files$ | async">
						@for (file of files$ | async; track $index) {
							<div class="col-6 col-sm-6 col-md-3 col-lg-2 col-xl-2 col-xxl-2 px-2">
								<div class="bg-light rounded position-relative">
									<div class="pay-master-wrapper-select-hover bg-dark rounded" (click)="selectFile(file)"></div>
									<div class="pay-img-wrapper text-center">
										<img class="pay-imgs rounded" [src]="file.path" [alt]="file.name" />
									</div>
								</div>
							</div>
						}
					</div>

					<!-- Pagination -->
					<div class="row m-0 my-8" *ngIf="(files$ | async) && totalCount > 0">
						<div class="row d-flex justify-content-between m-0 mt-8 p-0">
							<ngb-pagination
								(pageChange)="onPager($event)"
								class="pay-paginator"
								[collectionSize]="list_size$ | async"
								[pageSize]="tableInfo.pageSize"
								[page]="tableInfo.pageIndex"
								[maxSize]="3"
								[rotate]="true"
								[boundaryLinks]="true"
							></ngb-pagination>
							<div ngbDropdown class="pay-pag-right justify-content-end col-6">
								<span>{{ 'paginator_showing' | translate }}</span>
								<button class="text-muted btn btn-light btn-hover-primary p-0 px-4 pe-5" id="dropdownBasic2" ngbDropdownToggle>
									{{ tableInfo.pageSize }}
									<app-keenicon name="to-right" class="fs-6 text-muted pay-pagination-arrow-rotate-90"></app-keenicon>
								</button>
								<div ngbDropdownMenu aria-labelledby="dropdownBasic2">
									<button class="m-0" (click)="onPageSizeChange(p)" ngbDropdownItem *ngFor="let p of tableInfo.pageOptions">
										{{ p }}
									</button>
								</div>
								<span>{{ 'paginator_items' | translate }} &nbsp;</span>
								<span>
									{{ tableInfo.ini }} - {{ tableInfo.end }}
									{{ 'paginator_of' | translate }}
									{{ list_size$ | async }}
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="card-footer py-5 d-flex justify-content-between align-items-center" id="kt_select_files_footer">
			<button id="kt_select_files_close" type="button" class="hover-elevate-up btn btn-light d-flex justify-content-between round py-4" (click)="onClose()">
				<app-keenicon name="to-left" class="fs-3 text-muted me-3"></app-keenicon>
				<span class="text-muted font-size-sm" translate>drawer_back</span>
			</button>
		</div>
	</div>
</div>
